import reduceReducers from "reduce-reducers";
import { initialState as contentInitialState, reducer as contentReducer } from "../content";
import { initialState as contentUploadInitialState, reducer as contentUploadReducer } from "../contentUpload";
import { initialState as documentDetailsInitialState, reducer as documentDetailsReducer } from "../documentDetails";
import { initialState as documentEditorPanelInitialState, reducer as documentEditorPanelReducer } from "../documentEditorPanel";
import { initialState as graphInitialState, reducer as graphReducer, neuralInterfaceActionInitialState, neuralInterfaceActionReducer } from "../graph";
import { initialState as mapInitialState, reducer as mapReducer } from "../map";
import { initialState as tableInitialState, reducer as tableReducer } from "../table";
export const initialState = {
    ...documentEditorPanelInitialState,
    ...documentDetailsInitialState,
    ...graphInitialState,
    ...mapInitialState,
    ...contentInitialState,
    ...contentUploadInitialState,
    ...tableInitialState,
    ...neuralInterfaceActionInitialState
};
export default reduceReducers(initialState, documentEditorPanelReducer, documentDetailsReducer, graphReducer, mapReducer, contentReducer, contentUploadReducer, tableReducer, neuralInterfaceActionReducer);
